class ViewAsComponent extends HTMLElement {
  connectedCallback() {
    this.defaultView = this.getAttribute("products-view")
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    const buttonList = this.querySelector(".view-as__list-button");
    const buttonGrid = this.querySelector(".view-as__grid-button");

    buttonList.addEventListener("click", this.handleButtonClick.bind(this));
    buttonGrid.addEventListener("click", this.handleButtonClick.bind(this));

    // click of it is list
    document.addEventListener('DOMContentLoaded',() => {
      console.log(localStorage.getItem("listViewOpen"))
      if(this.defaultView === 'list' && !localStorage.getItem("listViewOpen")){
        const buttonList = this.querySelector(".view-as__list-button");
        buttonList.click();
      }else if(localStorage.getItem("listViewOpen")){
        localStorage.getItem("listViewOpen") === 'open' ? buttonList.click() : buttonGrid.click()
      }
    })
  }

  removeEventListeners() {
    const buttonList = this.querySelector(".view-as__list-button");
    const buttonGrid = this.querySelector(".view-as__grid-button");

    if (buttonList) {
      buttonList.removeEventListener("click", this.handleButtonClick.bind(this));
    }
    if (buttonGrid) {
      buttonGrid.removeEventListener("click", this.handleButtonClick.bind(this));
    }
  }

  handleButtonClick(event) {
    const buttonList = this.querySelector(".view-as__list-button");
    const buttonGrid = this.querySelector(".view-as__grid-button");

    if (event.currentTarget === buttonList) {
      buttonList.querySelector(".view-as__icon").classList.add("view-as__icon--active");
      buttonGrid.querySelector(".view-as__icon").classList.remove("view-as__icon--active");
    } else if (event.currentTarget === buttonGrid) {
      buttonGrid.querySelector(".view-as__icon").classList.add("view-as__icon--active");
      buttonList.querySelector(".view-as__icon").classList.remove("view-as__icon--active");
    }
  }
}

// Register the custom element
customElements.define("view-as-component", ViewAsComponent);
